import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import LoginPicture from "../../images/DoctorImage.svg";
import { Button, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { changePassword, getLogin } from "../../api/Login";
import Loader from "../../customJS/Loader";

function ChangePassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log("URl", atob(urlParams.get("signin")));
    setUserId(atob(urlParams.get("signin")));
  }, []);


  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = (values) => {
    var obj = {
      userId: userId,
      password: CryptoJS.MD5(values.password).toString(),
    };
    
    // console.log("LOGINUSER:", loginUser, values);

    setLoader(true);
    changePassword(obj)
      .then((response) => {
        if (response.data.status === 1 ) {
          messageApi.open({
            type: "success",
            content: "Password Created Successfully. Sign in to Continue.",
            duration: 1.5,
            className: "ant-alert",
            onClose: () => {
              navigate("/login");
              setLoader(false);
            },
          });
        } else if (response.data.status === -2) {
          messageApi.open({
            type: "error",
            content:
              "Your account has been deleted. Please contact the administrator for help.",
            duration: 2,
            className: "ant-alert",
          });
          setLoader(false);
        } else {
          messageApi.open({
            type: "error",
            content: "Something went wrong. Please try again.",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        messageApi.open({
          type: "error",
          content: "Network error, Please try again later.",
          duration: 1,
          className: "ant-alert",
        });
        setLoader(false);
      });
    // console.log("Success:", loginUser);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Prevent form submission when pressing Enter
      event.preventDefault();
    }
  };

  return (
    <Row className="m-0 d-flex justify-content-center align-items-center">
      {contextHolder}
      {loader && <Loader />}
      <Col lg={6} className="h-100">
        <div className="d-flex flex-column h-100 mx-md-5 px-md-5 justify-content-center">
          <div className="text-center">
            <h2 className="uniteColor">Create New Password</h2>
          </div>
          <div className="fromData">
            <Form
              form={form}
              name="createPassword"
              onFinish={onFinish}
              autoComplete="off"
              style={{ maxWidth: 400, margin: "0 auto" }}
              layout="vertical"
            >
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Password",
                  },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters",
                  },
                  {
                    max: 40,
                    message: "Password must not exceed 40 characters",
                  },
                  // {
                  //   pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  //   message:
                  //     "Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character.",
                  // },
                ]}
              >
                <Input.Password
                  placeholder="Enter your password"
                  autoComplete="off"
                />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="password2"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Please Enter Confirm Password",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder="Enter your password"
                  autoComplete="off"
                />
              </Form.Item>
              {/* <div className="d-grid gap-2"> */}
                <Button type="primary" block className="uniteButton py-4 mt-4" htmlType="submit" size="lg">
                  Submit
                </Button>
              {/* </div> */}
            </Form>
          </div>
        </div>
      </Col>
      <Col lg={6} className="d-flex justify-content-center">
        <img src={LoginPicture} alt="doctor image.png" />
      </Col>
    </Row>
  );
}

export default ChangePassword;
